
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardsTitle from "@/components/payment/prices/CardsTitle.vue";
  import AddPaymentCardForm from "@/components/payment/AddPaymentCardForm.vue";
  import PaymentCardsList from "@/components/payment/prices/PaymentCardsList.vue";

  import { Payment_Card } from "@/generated/graphql";

  @Component({
    components: {
      CardsTitle,
      AddPaymentCardForm,
      PaymentCardsList,
    },
  })
  export default class PaymentOptionsList extends Vue {
    @Prop({ type: Boolean, required: true }) readonly chosenCardProcessing!: boolean;
    @Prop({ type: Boolean, required: true }) readonly cardFormProcessing!: boolean;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Array, required: true }) readonly paymentCards!: Payment_Card[];
    @Prop({ type: String, required: true }) readonly cardFormTitle!: string;
    @Prop({ type: String, required: true }) readonly cardsListTitle!: string;
    @Prop({ type: String, default: undefined }) readonly errorMessage?: string;

    onAddCard(payload: { token: string }): void {
      this.$emit('addCard', payload)
    }

    onChooseCard(cardId: string): void {
      this.$emit('chooseCard', cardId)
    }
  }
